export const RemontMetricCounterNumber = 56439838;
export const RemontDevMetricCounterNumber = 57288148;
const YandexCounters = [RemontMetricCounterNumber];
if (typeof window !== 'undefined' &&
    (window.location.hostname === 'dev.vtblive.ru' || window.location.hostname === 'localhost')) {
    YandexCounters.push(RemontDevMetricCounterNumber);
}
export { YandexCounters };
export const YandexMethodNames = [
    'init',
    'addFileExtension',
    'extLink',
    'file',
    'getClientID',
    'hit',
    'notBounce',
    'params',
    'reachGoal',
    'replacePhones',
    'setUserID',
    'userParams',
];
//# sourceMappingURL=analytics.constants.js.map